import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayerTwo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m18.25 12-6.784 3.495c-.537.277-.806.415-1.088.47-.25.047-.506.047-.756 0-.282-.055-.55-.193-1.087-.47L1.75 12m0-4 6.785-3.495c.536-.276.805-.415 1.087-.469a2 2 0 0 1 .756 0c.282.054.55.193 1.088.47L18.25 8l-6.784 3.495c-.537.277-.806.415-1.088.47-.25.047-.506.047-.756 0-.282-.055-.55-.193-1.087-.47L1.75 8Z"
	})]
});
const ForwardRef = forwardRef(SvgLayerTwo);
export { ForwardRef as ReactComponent };
